import { Component } from '@angular/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CheckoutOrderSummaryComponent } from '@spartacus/checkout/base/components'

@Component({
    selector: 'app-custom-checkout-order-summary',
    templateUrl: './custom-checkout-order-summary.component.html',
    styleUrls: ['./custom-checkout-order-summary.component.scss'],
    standalone: false
})
export class CustomCheckoutOrderSummaryComponent extends CheckoutOrderSummaryComponent {
  constructor(activeCartFacade: ActiveCartFacade) {
    super(activeCartFacade)
  }
}
